var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRotateClockwise = function SvgRotateClockwise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Rotate Clockwise",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle Copy 8",
    fill: "#fff",
    stroke: "current",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 3.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.343 17.343a8 8 0 0 1 10.557-.657l2.17-2.171v6.434l-6.363-.07 2.765-2.765a5.993 5.993 0 0 0-8.358 8.358L16.685 27.9a7.988 7.988 0 0 1 .658-10.557Zm2.192 10.536a5.787 5.787 0 0 0 2.468 1.011v2.037a7.926 7.926 0 0 1-3.896-1.62Zm4.462 1.04a5.906 5.906 0 0 0 2.475-1.033l1.428 1.428a7.908 7.908 0 0 1-3.897 1.606Zm3.889-2.447a5.807 5.807 0 0 0 1.025-2.468h2.008a7.908 7.908 0 0 1-1.605 3.896Z",
    fill: "#376996"
  })));
};
export default SvgRotateClockwise;